import React from "react";
import { motion } from "framer-motion";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import { fdWorkflowSteps } from "../fdModulesData";

const stepIcons = [
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="1.5" />
      <path d="M16 16l4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M6 6h15l-1.5 9H7.5L6 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M6 6L5 3H2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M3 9l2-5h14l2 5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M4 9v10h16V9" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2L4 20h16L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <circle cx="12" cy="14" r="2" fill="currentColor" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5" />
      <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 2l2.5 7.5H22l-6 4.5 2.5 7.5L12 17l-6.5 4.5 2.5-7.5-6-4.5h7.5L12 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  ),
];

const FdHowItWorksSection: React.FC = () => {
  return (
    <section className="wdev-tech" aria-labelledby="fd-how-title">
      <div className="container">
        <AnimatedSection className="wdev-section-head wdev-section-head--center">
          <h2 id="fd-how-title" className="wdev-section-head__title">
            High-End Technology Deployed
          </h2>
          <p className="fd-section-lead">
            We have deployed high-end technology frameworks to bring out the most engaging
            multi-chain restaurant app that solicits and delivers desired benefits to users of
            different streams. Our cost-effective food delivery application works in multiple
            platforms and also operates as a device friendly system.
          </p>
        </AnimatedSection>

        <AnimatedSection className="wdev-section-head wdev-section-head--center fd-how-subhead" delay={0.1}>
          <h3 className="fd-how-subhead__title">How Our Food Delivery Platform Works</h3>
        </AnimatedSection>

        <div className="wdev-process__timeline fd-process-timeline">
          <div className="wdev-process__line" aria-hidden="true" />
          {fdWorkflowSteps.map((step, index) => (
            <motion.div
              key={step.title}
              className="wdev-process__step"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.08 }}
            >
              <div className="wdev-process__badge">{String(index + 1).padStart(2, "0")}</div>
              <div className="wdev-process__card">
                <div className="wdev-process__icon">{stepIcons[index]}</div>
                <h3 className="wdev-process__title">{step.title}</h3>
                <p className="wdev-process__desc">{step.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FdHowItWorksSection;
